import { render, staticRenderFns } from "./StaffMemberCard.vue?vue&type=template&id=49ecb28f&"
import script from "./StaffMemberCard.vue?vue&type=script&lang=js&"
export * from "./StaffMemberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports